import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: {
	headline: MessageDescriptor;
	body: MessageDescriptor;
	dismissButton: MessageDescriptor;
	tryMaxButton: MessageDescriptor;
} = defineMessages({
	headline: {
		id: 'post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.headline',
		defaultMessage: 'Meet Max. It handles everything.',
		description: 'Headline for the Max side navigation banner.',
	},
	body: {
		id: 'post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.body',
		defaultMessage: 'Max takes on complex, multi-step work for you.',
		description: 'Body text for the Max side navigation banner.',
	},
	dismissButton: {
		id: 'post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Button label for dismissing the Max side navigation banner.',
	},
	tryMaxButton: {
		id: 'post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.try-max-button',
		defaultMessage: 'Try Max',
		description: 'Button label for switching Rovo Chat to Max mode.',
	},
});

export default messages;
